import { onMount } from "solid-js";
import styles from "bundle-text:./styles/index.scss";
import { User } from "../../interfaces/user";

export function IntercomPlugin(user: User) {
  onMount(() => {

    const style = document.createElement("style");
    style.textContent = styles;
    document.head.appendChild(style);

    if (!document.getElementById("custom-intercom-launcher")) {
      const link = document.createElement("a");
      link.id = "custom-intercom-launcher";
      link.href = "#";

      const img = document.createElement("img");
      img.src = "https://cheetah.builderall.com/franquias/2/7291108/editor-html/12806286.png";
      img.alt = "Intercom";

      link.appendChild(img);
      document.body.appendChild(link);
    }

    window.intercomSettings = {
      api_base: "https://api-iam.intercom.io",
      app_id: "c619zjw6",
      custom_launcher_selector: "#custom-intercom-launcher",
      hide_default_launcher: true,
      user_id: user.id,
      name: user.name,
      email: user.email,
      created_at: Math.floor(new Date(user.created_at).getTime() / 1000),
    };

    if (typeof window.Intercom === "function") {
      window.Intercom("update", window.intercomSettings);
      return;
    }

    (function () {
      var w = window;
      var d = document;

      var i = function () { i.c(arguments); };
      i.q = [];
      i.c = function (args) { i.q.push(args); };
      w.Intercom = i;

      function setupEvents() {
        const launcher = document.getElementById("custom-intercom-launcher");
        if (!launcher) return;

        w.Intercom("onShow", () => launcher.classList.add("hidden"));
        w.Intercom("onHide", () => launcher.classList.remove("hidden"));
      }

      var s = d.createElement("script");
      s.async = true;
      s.src = "https://widget.intercom.io/widget/c619zjw6";
      s.onload = setupEvents;

      d.head.appendChild(s);
    })();

    console.info("[Intercom] initialized");
  });
}
